<div class="meter-list-selection">
  <label class="message">{{ 'module.shared.excelDownloadWizard.meterListLabelText' | translate }}</label>

  <div class="meter-list">
    <app-meter-table
      [checkedMeter]="checkedMeter"
      [isCurrent]="isCurrent"
      (checkMeter$)="onCheckMeter($event)"
      [isInMeterWizard]="true"
      [granularity]="granularity"
    ></app-meter-table>
  </div>
</div>
